import React, { useState, useEffect } from "react";
import { postDepto, getDeptos } from "../helpers/rutaDeptos";
import "../css/addrubroform.css";

import { Modal, Button } from "react-bootstrap";
import "../css/modalformalert.css";
import { FaThumbsUp } from "react-icons/fa";

const AddDeptoForm = ({ setShow }) => {
  const [formValues, setFormValues] = useState({
    depto: "",
  });

  const [deptos, setDeptos] = useState({
    data: [],
    loading: true,
  });

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      depto: formValues.depto,
    };

    try {
      const resp = await postDepto(payload);
      console.log("RESP POST DEPTO:", resp);
      console.log("ERROR POST DEPTO:", resp?.error);

      if (resp?.ok === false) {
        alert(
          resp?.error?.errors?.coddept?.message ||
            resp?.error?.message ||
            resp?.error ||
            "No se pudo guardar el depto"
        );
        return;
      }

      setFormValues({
        depto: "",
      });

      setShowSuccessModal(true);
    } catch (error) {
      console.error("❌ Error al guardar depto:", error);
      alert("Error al guardar depto");
    }
  };

  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    if (setShow) setShow(false);
  };

  useEffect(() => {
    getDeptos().then((datos) => {
      setDeptos({
        data: Array.isArray(datos?.deptos)
          ? datos.deptos
          : Array.isArray(datos)
          ? datos
          : [],
        loading: false,
      });
    });
  }, []);

  return (
    <>
      {!deptos.loading && (
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group mt-3 col-sm-4">
                <label>Departamento</label>
                <input
                  type="text"
                  className="form-control"
                  name="depto"
                  maxLength="30"
                  required
                  value={formValues.depto}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="btn btn-dark mt-5 mb-3"
                id="button"
              >
                Guardar
              </button>
            </div>
          </form>
        </div>
      )}

      <Modal show={showSuccessModal} onHide={handleSuccessClose} centered>
        <div className="custom-modal">
          <div className="custom-modal-icon">
            <FaThumbsUp />
          </div>

          <Modal.Body className="custom-modal-body">
            <h4>Info</h4>
            <p>¡Registro agregado correctamente!</p>
          </Modal.Body>

          <Button className="custom-modal-button" onClick={handleSuccessClose}>
            Aceptar
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default AddDeptoForm;